var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolSearchIcDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4887 39.5278L52.5 52.5M45 26.25C45 36.6052 36.6052 45 26.25 45C15.8947 45 7.5 36.6052 7.5 26.25C7.5 15.8947 15.8947 7.5 26.25 7.5C36.6052 7.5 45 15.8947 45 26.25Z",
    stroke: "#FFB629",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolSearchIcDiscovery);
export default __webpack_public_path__ + "static/media/sol-search-ic-discovery.099573cb4ae58db16194e526513cfa1a.svg";
export { ForwardRef as ReactComponent };